import { ComponentSettings, FieldTypes } from "../settings/settings";

const field = {
  work_type: {
    type: FieldTypes.value,
    text: { de: "Vorgangstyp", en: "Operation Type", nl: "Bewerkingstype" }
  },
  create_time: {
    type: FieldTypes.number,
    text: { de: "Startzeit", en: "Start Time", nl: "Starttijd" }
  },
  complete_time: {
    type: FieldTypes.number,
    text: { de: "Endzeit", en: "Complete Time", nl: "Voltooiingstijd" }
  },
  duration: {
    type: FieldTypes.number,
    text: { de: "Laufzeit", en: "Duration", nl: "Duur" }
  },
  user_id: {
    type: FieldTypes.value,
    text: { de: "Ausgeloest durch", en: "Triggered by", nl: "Gestart door" }
  },
  work_log: {
    type: FieldTypes.data,
    text: { de: "Log", en: "Log", nl: "Log" }
  },
  content: {
    type: FieldTypes.value,
    text: { de: "Grund", en: "Cause", nl: "Reden" }
  },
  migration_id: {
    type: FieldTypes.number,
    text: {
      de: "Migrations-ID",
      en: "Migration ID",
      nl: "Migratie-ID"
    }
  },
  migration_key: {
    type: FieldTypes.value,
    text: { de: "Migration", en: "Migration", nl: "Migratie" }
  },
  last_status: {
    type: FieldTypes.value,
    text: { de: "Letzter Status", en: "Last Status", nl: "Laatste status" }
  },
  last_forced: {
    type: FieldTypes.value,
    text: { de: "Erzwungen", en: "Forced", nl: "Geforceerd" }
  },
  last_started_at: {
    type: FieldTypes.number,
    text: { de: "Gestartet am", en: "Started At", nl: "Gestart op" }
  },
  last_completed_at: {
    type: FieldTypes.number,
    text: {
      de: "Abgeschlossen am",
      en: "Completed At",
      nl: "Voltooid op"
    }
  },
  last_error_message: {
    type: FieldTypes.value,
    text: { de: "Fehler", en: "Error", nl: "Fout" }
  },
  total_runs: {
    type: FieldTypes.number,
    text: { de: "Anzahl Laeufe", en: "Total Runs", nl: "Totaal aantal runs" }
  },
  run_id: {
    type: FieldTypes.value,
    text: { de: "Lauf-ID", en: "Run Id", nl: "Run-ID" }
  },
  status: {
    type: FieldTypes.value,
    text: { de: "Status", en: "Status", nl: "Status" }
  },
  forced: {
    type: FieldTypes.value,
    text: { de: "Erzwungen", en: "Forced", nl: "Geforceerd" }
  },
  requested_by: {
    type: FieldTypes.value,
    text: {
      de: "Angefordert von",
      en: "Requested By",
      nl: "Aangevraagd door"
    }
  },
  started_at: {
    type: FieldTypes.number,
    text: { de: "Gestartet am", en: "Started At", nl: "Gestart op" }
  },
  completed_at: {
    type: FieldTypes.number,
    text: {
      de: "Abgeschlossen am",
      en: "Completed At",
      nl: "Voltooid op"
    }
  },
  error_message: {
    type: FieldTypes.value,
    text: { de: "Fehler", en: "Error", nl: "Fout" }
  }
};

const settings = {
  text: {
    operations: {
      de: "Betriebsleiter",
      en: "Operations Manager",
      nl: "Operationsmanager"
    },
    actionsTitle: {
      de: "Betrieb Aktionen",
      en: "Operations Actions",
      nl: "Operationele acties"
    },
    historyTitle: {
      de: "Betrieb Historie",
      en: "Operations History",
      nl: "Operationele geschiedenis"
    },
    run: {
      de: "Lauf",
      en: "Run",
      nl: "Rennen"
    },
    all: {
      de: "Alle",
      en: "All",
      nl: "Alle"
    },
    matchParts: {
      de: "Einheiten matchen",
      en: "Match Items",
      nl: "Match Items"
    },
    requestDetails: {
      de: "Details abfragen",
      en: "Request Details",
      nl: "Details aanvragen"
    },
    updateDetails: {
      de: "Details setzen",
      en: "Update Details",
      nl: "Details bijwerken"
    },
    generateTree: {
      de: "Baum generieren",
      en: "Generate Tree",
      nl: "Boom genereren"
    },
    deleteDocs: {
      de: "Dokumente löschen",
      en: "Delete Docs",
      nl: "Documenten verwijderen"
    },
    buildBOM: {
      de: "BOM erstellen",
      en: "Build BOM",
      nl: "BOM opbouwen"
    },
    updateImpacts: {
      de: "Auswirkungen aktualisieren",
      en: "Update Impacts",
      nl: "Impacten bijwerken"
    },
    updateTaskResponsibles: {
      de: "Aufgaben aktualisieren Zuständigkeiten",
      en: "Update Tasks Responsibles",
      nl: "Taken bijwerken Verantwoordelijken"
    },
    matchPartsDescription: {
      de: "Bauteile matchen besteht aus der Suche nach einzelnen Teilenummern im Teilekatalog und der Zuordnung eines oder mehrerer Hersteller aus der Online-Datenbank.",
      en: "Match Parts consists of searching individual part numbers in the parts catalogue and assign one or multiple manufacturers from the online database.",
      nl: "Wedstrijd Onderdelen bestaat uit het zoeken van individuele onderdeelnummers in de onderdelencatalogus en het toewijzen van een of meerdere fabrikanten uit de online database."
    },
    requestDetailsDescription: {
      de: "Details abfragen besteht darin, detaillierte Daten über jede Teilenummer anzufordern und sie für die Berechnung von Schlüsseleigenschaften wie Obsoleszenzstatus usw. zu speichern.",
      en: "Request Details consists of requesting detailed data about each part number and storing it for calculating key properties like Obsolescence Status, etc.",
      nl: "Details aanvragen bestaat uit het opvragen van gedetailleerde gegevens over elk onderdeelnummer en het opslaan ervan voor het berekenen van belangrijke eigenschappen zoals de verouderingsstatus, enz."
    },
    updateDetailsDescription: {
      de: "Details setzen besteht darin, alle Herstellerdaten für ein Teil zu aggregieren, dann die Eigenschaften aller Unterteile in der Baugruppe zu aggregieren und dann zusätzliche Warnungen für die Änderungen zu erstellen.",
      en: "Update Details consists of aggregating all manufacturers' data for one part, then aggregating all sub-parts's properties into the assembly, and then creating additional Alerts for the changes.",
      nl: "Details bijwerken bestaat uit het samenvoegen van alle gegevens van de fabrikant voor één onderdeel, vervolgens het samenvoegen van de eigenschappen van alle subonderdelen in de assemblage, en vervolgens het aanmaken van bijkomende waarschuwingen voor de wijzigingen."
    },
    generateTreeDescription: {
      de: "Die Generierung des Baums besteht in der Erstellung/Aktualisierung der Daten, die im Baum angezeigt werden. Nach der Generierung bleiben die Daten unverändert, bis der Baum aufgrund von Auslösern (Import / Manuelle Bearbeitung einer Baugruppe / Manuelle Auslösung (nur für die Administratorrolle)) neu generiert wird.",
      en: "Generate Tree consists on creating/updating the data the is displayed on the tree. Once generated the data stays the same until the tree is regenerated on triggers (Import / Manual editing of an assembly / Manual triggered (Admin role only)). The newly uploaded data won't be displayed unless the tree has been generated after the upload.",
      nl: "Genereer boom bestaat uit het creëren/updaten van de gegevens die worden weergegeven in de boom. Eenmaal gegenereerd blijven de gegevens hetzelfde totdat de boom wordt geregenereerd op triggers (import / handmatig bewerken van een assembly / handmatig getriggerd (alleen Admin rol)). De nieuw geuploade gegevens zullen niet worden weergegeven tenzij de boom is gegenereerd na de upload."
    },
    deleteDocsDescription: {
      de: "Die Löschung der Dokumente wurde erfolgreich ausgelöst! Bitte aktualisieren Sie die Seite, um die Änderungen zu sehen.",
      en: "The deletion of the documents has been triggered successfully! Please refresh the page to see the changes.",
      nl: "The deletion of the documents has been triggered successfully! Please refresh the page to see the changes."
    },
    buildBOMDescription: {
      de: "Build BOM besteht aus der Erstellung einer Liste aller erweiterten Unterteile für jede CPN im System. Dies ist ein zeitaufwändiger Vorgang, der daher separat ausgeführt werden sollte. Er muss vor 'Details setzen' ausgeführt werden, da sonst falsche Daten in die Struktur gelangen können.",
      en: "Build BOM consists of building a list of all expanded sub-parts for each CPN in the system. This is a time consuming operation so it should be run separately. Must be run before 'Update Details' otherwise wrong data may end up in the Tree.",
      nl: "De BOM samenstellen bestaat uit het samenstellen van een lijst met alle uitgebreide subonderdelen voor elke CPN in het systeem. Dit is een tijdrovende bewerking en moet daarom apart worden uitgevoerd. Moet worden uitgevoerd vóór 'Details bijwerken', anders kunnen er verkeerde gegevens in de boomstructuur terechtkomen."
    },
    updateImpactsDescription: {
      de: "Auswirkungen aktualisieren bedeutet, alle Auswirkungen aus allen Threads auf Grundlage der Fahrzeugdokumente zu aktualisieren.",
      en: "Update impacts consists of updating all impacts from all threads based on the vehicles documents",
      nl: "Impacten bijwerken bestaat uit het bijwerken van alle impacten uit alle threads op basis van de voertuigdocumenten."
    },
    generateAlertsDescription: {
      de: "Warnungen generieren bedeutet, die aktuellen Teil- und Baugruppendaten anhand der konfigurierten Regeln neu zu bewerten und daraus neue Warnungen sowie aktualisierte Warnungsstatus fuer den aktuellen Kunden zu erzeugen. Bei MTU wird dabei die konfigurierte Standardreichweite (PS4) verwendet.",
      en: "Generate Alerts consists of re-evaluating the current part and assembly data against the configured rules in order to create new alerts and refresh the alert status for the current customer. For MTU this also uses the configured Standard Range (PS4).",
      nl: "Waarschuwingen genereren bestaat uit het opnieuw beoordelen van de huidige onderdeel- en assemblagegegevens aan de hand van de geconfigureerde regels om nieuwe waarschuwingen te maken en de waarschuwingsstatus voor de huidige klant te vernieuwen. Voor MTU wordt daarbij ook de geconfigureerde Standard Range (PS4) gebruikt."
    },
    auditLogsDescription: {
      de: "Audit-Protokolle zeigen, wer kritische Aktionen ausgefuehrt hat, wann sie stattgefunden haben und was der Grund fuer die Protokollierung ist.",
      en: "Audit Logs show who performed critical actions, when they happened, and which is the reason for logging.",
      nl: "Auditlogboeken tonen wie kritieke acties heeft uitgevoerd, wanneer die hebben plaatsgevonden en wat de reden voor de registratie is."
    },
    migrationHistoryDescription: {
      de: "Die Migrationshistorie zeigt die letzten ausgefuehrten Migrationen fuer den aktuellen Kunden sowie Status, Start- und Endzeit und bisherige Ausfuehrungen.",
      en: "Migration History shows the latest migrations executed for the current customer, including status, start and end time, and previous runs.",
      nl: "Migratiegeschiedenis toont de laatst uitgevoerde migraties voor de huidige klant, inclusief status, start- en eindtijd en eerdere runs."
    },
    inProgressMessage: {
      de: "In Bearbeitung",
      en: "In progress",
      nl: "In uitvoering"
    },
    remainingCount: {
      de: "verbleibend",
      en: "remaining",
      nl: "resterend"
    },
    usedCount: {
      de: "gebraucht",
      en: "used",
      nl: "gebruikt"
    },
    limitCount: {
      de: "Limit fuer Einheitendetails",
      en: "Item Detail Limit",
      nl: "Limiet voor itemdetails"
    },
    expirationDate: {
      de: "Ablaufdatum",
      en: "Expiration Date",
      nl: "Vervaldatum"
    },
    createDate: {
      de: "Erstellungsdatum",
      en: "Creation Date",
      nl: "Aanmaakdatum"
    },
    generateAlerts: {
      de: "Warnungen generieren",
      en: "Generate Alerts",
      nl: "Waarschuwingen genereren"
    },
    recalculateGlobalStock: {
      de: "Global Stock neu berechnen",
      en: "Recalculate Global Stock",
      nl: "Global Stock herberekenen"
    },
    recalculateGlobalStockDescription: {
      de: "Global Stock neu berechnen aktualisiert den Global Stock fuer alle Teile.",
      en: "Recalculate Global Stock updates Global Stock for all parts.",
      nl: "Global Stock herberekenen werkt Global Stock bij voor alle onderdelen."
    },
    seeAuditLogs: {
      de: "Audit-Protokolle",
      en: "Audit Logs",
      nl: "Auditlogboeken"
    },
    seeMigrationHistory: {
      de: "Migrationshistorie",
      en: "Migration History",
      nl: "Migratiegeschiedenis"
    },
    migrationHistoryTitle: {
      de: "Migrationshistorie",
      en: "Migration History",
      nl: "Migratiegeschiedenis"
    },
    migrationRunsTitle: {
      de: "Migrationslaeufe",
      en: "Migration Runs",
      nl: "Migratieruns"
    },
    saveData: {
      de: "Daten speichern",
      en: "Save data",
      nl: "Gegevens opslaan"
    },
    userId: {
      de: "Benutzer",
      en: "User",
      nl: "Gebruiker"
    },
    time: {
      de: "Zeit",
      en: "When",
      nl: "Wanneer"
    },
    reason: {
      de: "Grund",
      en: "Reason",
      nl: "Reden"
    },
    completed: {
      de: "Abgeschlossen",
      en: "Completed",
      nl: "Voltooid"
    },
    failed: {
      de: "Fehlgeschlagen",
      en: "Failed",
      nl: "Mislukt"
    },
    running: {
      de: "Laeuft",
      en: "Running",
      nl: "Wordt uitgevoerd"
    },
    noMigrationHistoryAvailable: {
      de: "Keine Migrationshistorie vorhanden",
      en: "No migration history available yet",
      nl: "Nog geen migratiegeschiedenis beschikbaar"
    },
    noMigrationRunsAvailable: {
      de: "Keine Migrationslaeufe vorhanden",
      en: "No migration runs available yet",
      nl: "Nog geen migratieruns beschikbaar"
    },
    noAuditLogsAvailable: {
      de: "Keine Audit-Protokolle vorhanden",
      en: "No audit logs available yet",
      nl: "Nog geen auditlogboeken beschikbaar"
    },
    noHistoryAvailable: {
      de: "Noch keine Historie vorhanden",
      en: "No history available yet",
      nl: "Nog geen geschiedenis beschikbaar"
    },
    currentDataProvider: {
      de: "Datenanbieter fuer den aktuellen Kunden ist:",
      en: "Data provider for the current customer is:",
      nl: "Dataprovider voor de huidige klant is:"
    }
  },
  url: {},
  field,
  list: {
    columns: [
      "operations.work_type",
      "operations.create_time",
      "operations.complete_time",
      "operations.duration",
      "operations.user_id",
      "operations.work_log"
    ],
    auditColumns: [
      "operations.user_id",
      "operations.create_time",
      "operations.content"
    ],
    migrationColumns: [
      "operations.migration_id",
      "operations.migration_key",
      "operations.last_status",
      "operations.last_forced",
      "operations.last_started_at",
      "operations.last_completed_at",
      "operations.last_error_message",
      "operations.total_runs"
    ],
    migrationRunColumns: [
      "operations.run_id",
      "operations.status",
      "operations.forced",
      "operations.requested_by",
      "operations.started_at",
      "operations.completed_at",
      "operations.error_message"
    ]
  },
  permission: {
    seeOperations: false,
    seeOperationsHistory: false,
    seeMatchParts: false,
    seeRequestDetails: false,
    seeUpdatesDetails: false,
    seeGenerateTree: false,
    seeBuildBOM: false,
    seeUpdatesImpacts: false,
    seeGenerateAlerts: false,
    seeRecalculateGlobalStock: false,
    seeAuditLogs: false
  },
  additionalInfo: {}
};

export const operations: ComponentSettings<typeof settings> = settings;
